import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { FirstNameInput } from '../../../BasePersonInputs/FirstName/FirstNameInput';

export function FirstNameField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <FirstNameInput
      value={value as string}
      onChange={onChange}
      label='Firmenname'
    />
  );
}
